import { FC } from 'react';
import * as R from 'ramda';
import { Connection, Handle, NodeProps, Position } from 'react-flow-renderer';
import Node, { contentStyle as style } from './Node';
import { Badge, Box } from '@mui/material';

const isValidInput = (connection: Connection) => {
  return R.split('_', connection.source as string)[0] === 'condicional';
};
const isValidOutput = (connection: Connection) => {
  return R.split('_', connection.target as string)[0] === 'campanhaOnl';
};

export const SleepNode: FC<NodeProps> = ({ data, selected, }) => {
  return (
    <Badge badgeContent={data.erros | 0} color="error">
      <Node
        label='Sleep'
        icon='timer'
        selected={selected}
        color={'#C2A95F'}
        content={
          <>
            <Box style={style.io}>
              <Handle
                type='target'
                position={Position.Left}
                id='i__data'
                style={{ ...style.handle, ...style.left }}
                isValidConnection={isValidInput}
              />
              {data.label}

            </Box>
            {data.sleepTime && (<Box style={{ ...style.io, ...style.textRight }}>
              {`${data.sleepTime} minuto${data.sleepTime > 1 ? 's' : ''}`}
              <Handle
                type='source'
                position={Position.Right}
                id='o__data'
                style={{ ...style.handle, ...style.right }}
                isValidConnection={isValidOutput}
              />
            </Box>
            )}
          </>
        }
      />
    </Badge>
  );
};
